export interface BlotterComponentState {
    selectedRowIds: number[];
}

export const initialBlotterComponentState: BlotterComponentState = {
    selectedRowIds: [],
};
